/* Soleil d'Or — pages collection (v2, octobre 2026)
   Les rangées défilent avec le rail de l'accueil (assets/sdo-rail.js).
   Ce fichier ne garde que : la sous-collection active visible dans la
   rangée de boutons sur mobile. */
(function () {
  if (window.__sdoCollection) return;
  window.__sdoCollection = true;

  function init() {
    var active = document.querySelector('.sdo-pill[aria-current="page"]');
    var list = active && active.closest('[data-sdo-pills]');
    if (!list || list.scrollWidth <= list.clientWidth) return;
    var r = active.getBoundingClientRect();
    var lr = list.getBoundingClientRect();
    if (r.right > lr.right) list.scrollLeft += r.left - lr.left - 16;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
